var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classData},[(_vm.isJson(_vm.fieldData))?[_vm._v(" "+_vm._s(_vm.selectedData)+" ")]:[_vm._v(" "+_vm._s(_vm.value)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }